import sa from 'sa-sdk-javascript';
import config from '@/commons/config';

console.log('::config::', config.saurl);
function init() {
  sa.init({
    server_url: config.saurl,
    heatmap: {
      // 是否开启点击图，默认 default 表示开启，自动采集 $WebClick 事件，可以设置 'not_collect' 表示关闭
      clickmap: 'not_collect',
      // 是否开启触达注意力图，默认 default 表示开启，自动采集 $WebStay 事件，可以设置 'not_collect' 表示关闭
      scroll_notice_map: 'not_collect',
    },
  });
  sa.quick('autoTrack');

  return sa;
}

function install(Vue) {
  const instance = init();

  Vue.prototype.$sa = instance;
  Vue.prototype.$track = instance.track;

  // 神策
  Vue.mixin({
    data() {
      return {
        sa: sa,
      };
    },
  });
}

export default {
  install,
};
